<th
  id="select-all"
  class="select-box"
  [class.max-selected]="isMaxSelectionReached"
  *ngIf="showCheckbox"
  [pTooltip]="
    isMaxSelectionReached
      ? 'Maximum selection limit of ' + maxSelectionLimit + ' items reached'
      : ''
  "
  tooltipPosition="right"
>
  <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
</th>
<th
  [id]="col.fields"
  [pSortableColumn]="col.isSortDisabled ? null : col.sortField || col.field"
  *ngFor="let col of columns"
  [ngStyle]="{
    width: col.width ? col.width : null,
    'pointer-events': col.isHidden ? 'none' : 'auto'
  }"
>
  <div class="table-head" *ngIf="!col.isHidden">
    <div class="table-head__field">
      <ng-container [ngSwitch]="col?.type">
        <hospitality-bot-checkbox
          *ngSwitchCase="'checkbox'"
          [customWrapperClass]="checkboxClass"
          [label]="col.header"
          [value]="!bindToCheckboxControl ? checked : null"
          [controlName]="bindToCheckboxControl ? col.field : undefined"
          [description]="col.description"
          (change)="onCheckboxChange.emit($event.checked, col.field)"
        >
        </hospitality-bot-checkbox>
        <div class="col-heading" *ngSwitchDefault>
          {{ col.header }}

          <ng-container *ngIf="col.tooltipMessage?.length">
            <ng-container
              *ngTemplateOutlet="toolTip; context: { col: col }"
            ></ng-container>
          </ng-container>
        </div>
      </ng-container>

      <div class="col-sort" *ngIf="!col.isSortDisabled">
        <p-sortIcon [field]="col.sortField || col.field"></p-sortIcon>
      </div>
    </div>
    <ng-container *ngIf="showSearch">
      <div
        class="table-head__search"
        click-stop-propagation
        *ngIf="isSearchActive"
      >
        <input
          pInputText
          type="text"
          (input)="onSearch($event.target.value, col)"
          [placeholder]="col.placeholder ? col.placeholder : ''"
          [disabled]="col.isSearchDisabled"
          class="p-column-filter"
        />
      </div>
    </ng-container>
  </div>
</th>

<ng-template #toolTip let-col="col">
  <span
    [class]="col?.customColClass || 'pi pi-question-circle header-icon'"
    pTooltip="This is Restricted Field"
    tooltipPosition="right"
    style="cursor: pointer;"
    [pTooltip]="col.tooltipMessage"
  ></span>
</ng-template>
